import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGauge } from '@fortawesome/free-solid-svg-icons';

import { FormattedValue } from './FormattedValue';

interface AirPressureStatsProps {
    airPressure: number;
    isLoaded: boolean;
}

const AirPressureStats: React.FC<AirPressureStatsProps> = ({ airPressure, isLoaded }) => {

    return <div className="column is-one-third metric rain-container">
                <div className="is-flex is-flex-direction-column">
                    <FontAwesomeIcon color='mediumseagreen' size='2x' icon={faGauge} />
                    <FormattedValue isLoaded={isLoaded} value={airPressure} unit='hPa'></FormattedValue>
                </div>
            </div>
}

export default AirPressureStats;
